import { atom } from "recoil";

export const triggerHandleSubmitStep2 = atom<boolean>({
  key: "triggerHandleSubmitStep2",
  default: false,
});
